module.exports = __webpack_public_path__ + "static/media/cross.04a845b8.svg";